import "../sass/main.scss";
import PhotoSwipeLightbox from './photoswipe/photoswipe-lightbox.esm.js';
// import Swiper JS
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import Swiper from 'swiper/bundle';

window.Alpine = Alpine
 
Alpine.start()
Alpine.plugin(intersect)

// import Swiper styles


const swiper = new Swiper('.swiper', {
    // Optional parameters
    // direction: 'vertical',
    slidesPerView: 1.5,
    spaceBetween: 30,
    breakpoints: {
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 50,
        },
      },
    loop: true,
  
    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });


window.addEventListener("load", function() {
    setKeyHeights();
    getGalleries();
    setScrolling();
});

let resizeTimer;
window.addEventListener("resize", function() {
    
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        setKeyHeights();
        console.log("resize");
    }, 250); // Adjust the delay (250ms) as needed
});

function setKeyHeights() {
    //  let subMenu= jQuery("#horizontal-menu").outerHeight();
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // document.documentElement.style.setProperty("--headerTotalHeight", totalHeaderHeight + "px");
};

function getGalleries() {
    const galleries = document.querySelectorAll(".pswp-gallery");
    galleries.forEach(function(gallery) {
        console.log("gallery");
        const galleryId = gallery.getAttribute("id");
        createGallery(galleryId);
    });
}

function setScrolling(){
// Set up ScrollTrigger
const toggle = document.querySelector(".bmi_head-container");
gsap.registerPlugin(ScrollTrigger);
console.log("setScrolling");
// Create a ScrollTrigger instance
const scrollTrigger = ScrollTrigger.create({
  start: "top -100px", // Trigger when scrolled 100px from the top
  end: "bottom bottom", // End when scrolled to the bottom of the viewport
  
  onEnter: () => {
    toggle.classList.add("scrolling");
  },
  onLeaveBack: () => {
    toggle.classList.remove("scrolling");
  }
});
}

function createGallery(galleryId) {

    console.log("createGallery " + galleryId);
    const lightbox = new PhotoSwipeLightbox({
        // may select multiple "galleries"
        gallery: '#' + galleryId,
      
        // Elements within gallery (slides)
        children: 'a',
      
        // setup PhotoSwipe Core dynamic import
        pswpModule: () => import('./photoswipe/photoswipe.esm.js')
      });
      lightbox.init();
}

//TABS
function setTabs(itemTabId) { 
  jQuery('#'+itemTabId).responsiveTabs({
      startCollapsed: 'accordion'
  });
  };
  
  
  function setSliderHeight() {
  var laySlider = document.querySelector(".lbc-lay-gallery");
  var slideBox = document.getElementById("js-sc-height");
  var laySliderWidth = laySlider.offsetWidth;
  
  console.log("width " + laySliderWidth);
  gsap.set(slideBox, {
      height: laySliderWidth * 0.56
  });
  }
  
  
  function updateDraggable() {
  timer.restart(true);
  slideAnimation.kill();
  this.update();
  }
  
  function animateSlides(direction) {
  
  timer.restart(true);
  slideAnimation.kill();
  
  var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
  
  slideAnimation = gsap.to(proxy, {
      x: x,
      duration: slideDuration,
      onUpdate: updateProgress
  });  
  }
  
  function autoPlay() {  
  if (draggable.isPressed || draggable.isDragging || draggable.isThrowing) {
      timer.restart(true);
  } else {
      animateSlides(-1);
  }
  }
  
  function updateProgress() { 
  animation.progress(progressWrap(gsap.getProperty(proxy, "x") / wrapWidth));
  }
  
  function resize() {
  
  var norm = (gsap.getProperty(proxy, "x") / wrapWidth) || 0;
  
  slideWidth = slides[0].offsetWidth;
  wrapWidth = slideWidth * numSlides;
  snapX = gsap.utils.snap(slideWidth);
  
  gsap.set(proxy, {
      x: norm * wrapWidth
  });
  setSliderHeight() 
  animateSlides(0);
  slideAnimation.progress(1);
  }
  ;((d,w)=>{
      const focusFirstInput = ( id => {
          //500ms delay to allow for rendering of orms in popups
          setTimeout(()=>{
              const element = d.getElementById(id);
              if(element){
                  const firstInput = element.querySelector('input:not([type="hidden"])');
                  firstInput.focus();
              }
          }, 500);
      })
      
      if(undefined === w._WPG){ w._WPG = {} }
      w._WPG.focusFirstInput = focusFirstInput;
      
  })(document, window)